import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/style.css'
import './assets/css/menu-override.css' // 导入菜单样式覆盖
import './assets/css/menu-override-fix.js' // 导入菜单修复脚本
import global_ from './components/common/Global'//引用全局变量
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面

// 导入按钮权限指令
import permission from './directives/permission'
Vue.use(permission) // 注册权限指令
//导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

//导入富文本css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// js跨域请求插件
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import MyEditor from "./components/common/MyEditor.vue"   //引入组件
Vue.component("my-editor", MyEditor);
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios'

// 配置axios的baseURL，确保与后端API服务器地址匹配
// 使用实际的后端服务器地址
// 其他可选地址
axios.defaults.baseURL = 'https://jianshenhtapi.tieshouyundong.com/'
Vue.prototype.deviceURL = 'https://control.tieshouyundong.com/'
Vue.prototype.ossURL = 'https://tieshou-user-face.oss-cn-wulanchabu.aliyuncs.com/'
// axios.defaults.baseURL = 'https://jianshenhtapi.girlfee.com/'
// axios.defaults.baseURL = 'http://192.168.0.66:7707/'
// axios.defaults.baseURL = 'https://jianshenhtapi.tieshouyundong.com/'

axios.interceptors.request.use(config => {
  // 检查是否是关闭标签页的请求
  const isClosingTab = window._isClosingTab ||
                      (config.headers && config.headers['X-Tab-Closing'] === 'true');

  // 如果是关闭标签页的请求，标记它
  if (isClosingTab) {
    config._isClosingTab = true;
    console.log('检测到关闭标签页请求:', config.url);
    // 对于关闭标签页的请求，直接取消以避免401错误
    return Promise.reject({
      isAxiosError: true,
      _isClosingTab: true,
      message: '标签页关闭请求被取消'
    });
  }

  // 定义不需要token的白名单路径
  const whiteListPaths = ['login', 'register', 'joinlogin', 'stores/', 'stores/info'];
  const isWhiteListPath = whiteListPaths.some(path => config.url && config.url.includes(path));

  // 获取各种token
  const adminToken = window.sessionStorage.getItem('admin_token'); // 用户名
  const loginToken = window.sessionStorage.getItem('login_token'); // JWT token
  const joinToken = window.sessionStorage.getItem('join_token');

  // 优先使用JWT token，而不是用户名
  const token = loginToken || joinToken || adminToken;

  if (token) {
    // 如果是getperlist请求，打印更多调试信息
    if (config.url && (config.url.includes('getperlist') || config.url === 'getperlist/' || config.url === 'getperlist')) {
      console.log('发送getperlist请求，设置请求头Authorization: Bearer ' + token);
      console.log('完整请求URL:', axios.defaults.baseURL + config.url);
      console.log('当前用户角色:', window.sessionStorage.getItem('roles'));
    }

    // 使用Bearer格式的token
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  } else {
    // 如果是白名单路径，不需要token也可以请求
    if (isWhiteListPath) {
      console.log('白名单路径请求，无需token:', config.url);
      // 标记这是一个白名单路径请求，即使401也不要重定向
      config.headers['X-Whitelist-Request'] = 'true';
      return config;
    }

    // 对于需要token但没有token的请求，取消请求
    console.warn('请求被取消：没有有效的token', config.url);

    // 返回一个被拒绝的Promise，这样请求不会发送到服务器
    return Promise.reject({
      isAxiosError: true,
      response: {
        status: 401,
        data: { msg: '未登录或登录已过期', code: 401 }
      }
    });
  }
});

axios.interceptors.response.use(
  response => response,
  error => {
      // 处理请求拦截器中拒绝的请求（本地拦截的401错误）
      if (!error.response && error.isAxiosError) {
          console.log('请求被本地拦截，可能是token无效');
          // 不做任何处理，静默失败，不显示错误提示
          return Promise.reject(error);
      }

      // 处理429状态码 - 请求过于频繁
      if (error.response && error.response.status === 429) {
          console.log('检测到429状态码 - 请求过于频繁');
          // 直接让错误传递到具体的组件处理，不在这里拦截
          return Promise.reject(error);
      }
      // 处理402状态码 - 单点登录冲突
      else if (error.response && error.response.status === 402) {
          console.log('检测到402状态码 - 单点登录冲突');

          // 清除所有可能的token
          window.sessionStorage.removeItem('login_token');
          window.sessionStorage.removeItem('admin_token');
          window.sessionStorage.removeItem('join_token');
          window.sessionStorage.removeItem('name_token');
          window.sessionStorage.removeItem('pass_token');
          window.sessionStorage.removeItem('perid_token');
          window.sessionStorage.removeItem('buttonPermissions');
          window.sessionStorage.removeItem('roles');

          // 直接跳转到登录页面，不显示任何对话框
          console.log('单点登录冲突，直接跳转到登录页');
          window.location.replace(window.location.origin + '/#/login');

          return Promise.reject(error);
      }
      // 处理401状态码 - 无权限访问
      else if (error.response && error.response.status === 401) {
          // 获取后端返回的错误类型
          const authErrorType = error.response.headers ? error.response.headers['x-auth-error-type'] : null;
          console.log('401错误类型:', authErrorType, '请求URL:', error.config ? error.config.url : 'unknown');

          // 检查是否是白名单请求
          const isWhitelistRequest = error.config && error.config.headers && error.config.headers['X-Whitelist-Request'] === 'true';
          if (isWhitelistRequest) {
              console.log('白名单路径请求的401错误，不进行重定向:', error.config.url);
              return Promise.reject(error);
          }

          // 如果是关闭标签页触发的请求，不显示错误提示
          const isTabClosingRequest = document.visibilityState === 'hidden' ||
                                     (error.config && error.config._isClosingTab);

          if (isTabClosingRequest) {
              console.log('标签页关闭时的请求，忽略401错误');
              return Promise.reject(error);
          }

          // 检查是否是页面刷新导致的401错误
          const isPageRefresh = !document.referrer ||
                              document.referrer.includes(window.location.host);

          // 检查当前路由是否与客服门店相关或卡片管理相关
          const currentPath = window.location.hash.substring(1); // 去除前面的#
          const isCustomerStorePath = currentPath === '/customer-stores' ||
                                   currentPath.startsWith('/customer-store-info/') ||
                                   currentPath.startsWith('/customer-user-info/');

          const isCardManagementPath = currentPath === '/cards' ||
                                     currentPath.startsWith('/card/');

          // 如果当前路由与客服门店相关或卡片管理相关，不清除token也不重定向
          if (isCustomerStorePath || isCardManagementPath) {
              console.log('客服门店或卡片管理相关页面的401错误，不清除token也不重定向');
              return Promise.reject(error);
          }

          // 对于其他页面，清除所有token
          window.sessionStorage.removeItem('login_token');
          window.sessionStorage.removeItem('admin_token');
          window.sessionStorage.removeItem('join_token');
          window.sessionStorage.removeItem('name_token');
          window.sessionStorage.removeItem('pass_token');
          window.sessionStorage.removeItem('perid_token');
          window.sessionStorage.removeItem('buttonPermissions');
          window.sessionStorage.removeItem('roles');

          // 如果是页面刷新，直接重定向到登录页而不显示提示
          if (isPageRefresh) {
              console.log('检测到页面刷新，直接重定向到登录页');
              window.location.replace(window.location.origin + '/#/login');
              return Promise.reject(error);
          }

          // 对于其他401错误，显示错误提示
          let errorMessage = '登录已过期，请重新登录';

          switch (authErrorType) {
              case 'MISSING_TOKEN':
                  errorMessage = '请先登录';
                  break;
              case 'TOKEN_INVALID':
                  errorMessage = 'Token无效，请重新登录';
                  break;
              case 'TOKEN_EXCEPTION':
                  errorMessage = 'Token验证异常，请重新登录';
                  break;
              default:
                  errorMessage = '登录已过期，请重新登录';
                  break;
          }

          alert(errorMessage);

          // 统一在提示后重定向到登录页
          setTimeout(() => {
              window.location.replace(window.location.origin + '/#/login');
          }, 100);
      }
      return Promise.reject(error);
  }
);

// main.js
Vue.filter('dateFormat', function(originValue, pattern = 'yyyy-MM-dd hh:mm:ss') {
    const dt = new Date(originValue);
    // 调用上面的 formatDate 函数，或者直接在内部实现逻辑
    return formatDate(dt, pattern);
});

Vue.config.productionTip = false
Vue.prototype.$http = axios
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

function formatDate(date, fmt) {
    // 如果是字符串或数字，先转为 Date 对象
    if (typeof date === 'string' || typeof date === 'number') {
        date = new Date(date);
    }

    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(),      // 日
        'h+': date.getHours(),     // 小时
        'm+': date.getMinutes(),   // 分
        's+': date.getSeconds(),   // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds()  // 毫秒
    };

    // 处理年份
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    // 处理月、日、时、分、秒
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
}
